export const fi = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Kyllä",
    No: "Ei",
    "You cannot go back from this position":
      "Et voi palata takaisin tästä kohdasta",
    Chapters: "Luvut",
    Start: "Aloitus",
    "Connecting to the Energy Valve":
      "Yhteyden muodostaminen energiaventtiiliin",
    "Control Source": "Säätölähde",
    "Do you know the design flow rate?":
      "Tiedätkö suunnittelun virtauksen?",
    "Flow Control": "Virtauksen säätö",

    "Is the building running off fixed or varying flow temperatures?":
      "Onko rakennuksessa kiinteät vai vaihtelevat virtauslämpötilat?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Vaihtelevat virtauslämpötilat (Delta-T manager -skaalaus)",

    "Fixed flow temperatures (Delta T Manager)":
      "Kiinteät virtauslämpötilat (Delta-T manager)",

    "I am not sure": "En ole varma",
    "Delta T Manager": "Delta T Manager",
    Scaling: "Skaalaus",
    "Do you know the power output?":
      "Tiedätkö, mikä on lähtöteho?",
    "Yes (Power Control)": "Kyllä (tehonsäätö)",
    "No (Position Control)": "Ei (asennon ohjaus)",
    "Power Control": "Tehonsäätö",
    "Position Control": "Asennon ohjaus",
    "Onboard Data Analysis": "Sisäinen data-analyysi",

    "Did you get a clear result from the Energy Valve?":
      "Saitko selkeän tuloksen energiaventtiilistä?",

    "How do you want to setup your Energy Valve?":
      "Kuinka haluat määrittää energiaventtiilisi?",

    "Would you like to connect to the cloud?":
      "Halutko muodostaa yhteyden pilvipalveluun?",

    "Cloud Connectivity": "Pilviliitettävyys",

    "Onboard Diagnostics / Download Data":
      "Sisäinen diagnostiikka / lataa tiedot",

    "Download Data": "Lataa tiedot",
    "Send optimization request": "Lähetä optimointipyyntö",
    End: "Lopetus",

    Subtitles: "Tekstitykset",
    Repeat: "Toista",
    Continue: "Jatka",
  },
};
